import { API_ROOT } from '../../config/config'

import { doGet, doPost, doPostFiles, doDownload } from './utils'

export const getSuspendForm = (projectVersionId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/suspended`
  return doGet(url)
}

export const updateSuspend = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/suspended`
  return doPostFiles(url, request)
}

export const getCancelSuspendForm = (projectVersionId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/cancel-suspended`
  return doGet(url)
}

export const updateCancelSuspend = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/cancel-suspended`
  return doPost(url, request)
}

export const getDownloadFileSuspended = (projectVersionId, fileId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/suspended/${fileId}/download`
  return doDownload(url)
}
